(function ($) {
    'use strict';

    $(document).ready(function () {
        // Accordion functionality for Single Product Page
        $('.js-accordion-trigger').on('click', function () {
            const $this = $(this);
            const $content = $this.next('.sp-accordion-content');

            if ($this.hasClass('is-open')) {
                $content.slideUp(300);
                $this.removeClass('is-open');
            } else {
                $content.slideDown(300);
                $this.addClass('is-open');
            }
        });

        // SKU placeholder injection
        const skuElement = $('.sku_wrapper .sku');
        const $placeholder = $('.sp-sku-placeholder');
        if (skuElement.length > 0 && $placeholder.length > 0) {
            $placeholder.html('<span class="sp-sku">SKU: ' + skuElement.text() + '</span>');
        }

        // Force Title Case for Title
        const $title = $('.sp-title');
        if ($title.length > 0) {
            const titleText = $title.text();
            const titleCase = titleText.toLowerCase().split(' ').map(function (word) {
                return (word.charAt(0).toUpperCase() + word.slice(1));
            }).join(' ');
            $title.text(titleCase);
        }

        // Force Gallery Opacity
        $('.woocommerce-product-gallery').css('opacity', '1');

        // Price and Stock Status Update Logic
        const $mainPrice = $('.sp-price-wrap .price');
        const $stockStatus = $('.sp-stock-status');
        const originalPrice = $mainPrice.length > 0 ? $mainPrice.html() : '';
        const originalStock = $stockStatus.length > 0 ? $stockStatus.html() : '';

        $(document).on('found_variation', '.variations_form', function (event, variation) {
            // Update Price
            if (variation.price_html && $mainPrice.length > 0) {
                $mainPrice.html(variation.price_html);
            }

            // Sync Stock Status to Top
            if ($stockStatus.length > 0) {
                const $dot = $stockStatus.find('.stock-dot');
                
                // Clear existing dynamic status
                $stockStatus.removeClass('is-low-stock').find('span, strong').not('.stock-dot').remove();
                
                // Try to get clean text from availability_html
                let availabilityText = variation.availability_html ? $(variation.availability_html).text().trim() : '';
                
                if (availabilityText) {
                    $stockStatus.append('<span>' + availabilityText + '</span>');
                    if (/\d/.test(availabilityText)) {
                        $stockStatus.addClass('is-low-stock');
                    }
                } else {
                    // Fallback to default "In stock" if on sale variation is selected but no specific text
                    $stockStatus.append('<span>In stock</span>');
                }
            }
        });

        $(document).on('reset_data', '.variations_form', function () {
            if ($mainPrice.length > 0) {
                $mainPrice.html(originalPrice);
            }
            if ($stockStatus.length > 0) {
                $stockStatus.removeClass('is-low-stock').find('span, strong').not('.stock-dot').remove();
                $stockStatus.append('<span>In stock</span>');
            }
        });

        // Initialize Slick Slider for Related Products
        const $relatedGrid = $('.sp-related-grid');
        if ($relatedGrid.length > 0) {
            $relatedGrid.slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                draggable: false,
                prevArrow: $('.sp-nav-prev'),
                nextArrow: $('.sp-nav-next'),
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }
    });

})(jQuery);
